import { render } from "./StylesCreatedForCustomers.vue?vue&type=template&id=65eaf570&scoped=true"
import script from "./StylesCreatedForCustomers.vue?vue&type=script&lang=js"
export * from "./StylesCreatedForCustomers.vue?vue&type=script&lang=js"

import "./StylesCreatedForCustomers.vue?vue&type=style&index=0&id=65eaf570&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65eaf570"]])

export default __exports__